module.exports = __webpack_public_path__ + "img/326513a.png";